import React, { useState } from 'react';
import SanitizedMarkdown from 'react-scale/components/design-system/SanitizedMarkdown';
import { Button } from 'design-system/Form';
import apiFetch, { defaultApiFetchErrorHandler } from 'react-scale/lib/api-fetch';

const description = `
### Description:
- This tool allows you to run the project health check script, populating the data on [this sheet](https://docs.google.com/spreadsheets/d/14MRNu1gl1kzaACXU5ZHEh6S9_WLFnHNJAodmAUzr6Os/edit#gid=191800933) 

##### Author: Carlos Gonzalez
---
`;

const HealthCheck = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleHealthCheck = async () => {
    setLoading(true);
    try {
      await apiFetch(null, 'corp-api/bee-tts-utils/health-check', {
        method: 'POST',
      });
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
    }
    setLoading(false);
  };

  const buttonText = () => {
    if (!loading) return 'Run health check';
    return 'Running...';
  };
  return (
    <div className="root">
      <section>
        <SanitizedMarkdown text={description} />
      </section>

      <section>
        <Button primary disabled={loading} requireConfirmation onClick={handleHealthCheck}>
          {buttonText()}
        </Button>
      </section>
    </div>
  );
};

export default HealthCheck;
